const CloseIcon = ({
  setDisplayActionModal = () => {},
}: {
  setDisplayActionModal?: (value: boolean) => void;
}): JSX.Element => {
  return (
    <svg
      onClick={() => setDisplayActionModal(false)}
      className="cursor-pointer"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="close-icon"
    >
      <path
        d="M12.8514 11.4999L16.9723 7.38864C17.1527 7.20819 17.2541 6.96343 17.2541 6.70823C17.2541 6.45302 17.1527 6.20827 16.9723 6.02781C16.7918 5.84735 16.5471 5.74597 16.2919 5.74597C16.0366 5.74597 15.7919 5.84735 15.6114 6.02781L11.5002 10.1486L7.38894 6.02781C7.20848 5.84735 6.96372 5.74597 6.70852 5.74597C6.45331 5.74597 6.20856 5.84735 6.0281 6.02781C5.84764 6.20827 5.74626 6.45302 5.74626 6.70823C5.74626 6.96343 5.84764 7.20819 6.0281 7.38864L10.1489 11.4999L6.0281 15.6111C5.93828 15.7002 5.86698 15.8062 5.81833 15.923C5.76968 16.0398 5.74463 16.165 5.74463 16.2916C5.74463 16.4181 5.76968 16.5433 5.81833 16.6601C5.86698 16.7769 5.93828 16.8829 6.0281 16.972C6.11719 17.0618 6.22318 17.1331 6.33997 17.1817C6.45675 17.2304 6.58201 17.2554 6.70852 17.2554C6.83503 17.2554 6.96029 17.2304 7.07707 17.1817C7.19385 17.1331 7.29985 17.0618 7.38894 16.972L11.5002 12.8511L15.6114 16.972C15.7005 17.0618 15.8065 17.1331 15.9233 17.1817C16.0401 17.2304 16.1653 17.2554 16.2919 17.2554C16.4184 17.2554 16.5436 17.2304 16.6604 17.1817C16.7772 17.1331 16.8832 17.0618 16.9723 16.972C17.0621 16.8829 17.1334 16.7769 17.182 16.6601C17.2307 16.5433 17.2557 16.4181 17.2557 16.2916C17.2557 16.165 17.2307 16.0398 17.182 15.923C17.1334 15.8062 17.0621 15.7002 16.9723 15.6111L12.8514 11.4999Z"
        fill="#9092A3"
      />
    </svg>
  );
};

export { CloseIcon };
